var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", attrs: { "data-cy": "modal-card" } },
    [
      _c("header", [
        _c("h3", [_vm._v("Alguien paga tu dividendo por tí")]),
        _c(
          "a",
          {
            staticClass: "close-modal-button",
            on: {
              click: function ($event) {
                return _vm.$emit("is-modal-active", false)
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("@/ui/assets/img/plus-button.svg") },
            }),
          ]
        ),
      ]),
      _c("p", { staticClass: "description-text" }, [
        _vm._v(
          " Si utilizas transferencia electrónica como medio de pago, aquí puedes indicarnos los datos de una persona distinta de ti para que podamos reconocer rápidamente el abono. "
        ),
      ]),
      _c(
        "div",
        { staticClass: "add-section" },
        [
          !_vm.showAddTrustedIdInput
            ? _c(
                "b-button",
                {
                  staticClass: "is-button-primary add-button",
                  attrs: {
                    id: "button-add-person",
                    type: "is-medium",
                    "icon-left": "fas fa-user-plus",
                    rounded: "",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showAddTrustedIdInput = !_vm.showAddTrustedIdInput
                    },
                  },
                },
                [_vm._v(" Agregar persona ")]
              )
            : _vm._e(),
          _vm.showAddTrustedIdInput
            ? _c(
                "div",
                {
                  staticClass: "card-item input-card",
                  attrs: { id: "div-add-person" },
                },
                [
                  _c("div", { staticClass: "input-card-name" }, [
                    _c("p", { staticClass: "is-size-6 p-title" }, [
                      _vm._v("Nombre:"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.trustedIdToAdd.name,
                          expression: "trustedIdToAdd.name",
                        },
                      ],
                      staticClass: "input is-small input-name",
                      attrs: {
                        id: "input-name",
                        type: "text",
                        size: "is-small",
                      },
                      domProps: { value: _vm.trustedIdToAdd.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.trustedIdToAdd,
                            "name",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "input-card-rut" }, [
                    _c("p", { staticClass: "is-size-6 p-title-rut" }, [
                      _vm._v("Rut:"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.trustedIdToAdd.idNumber,
                          expression: "trustedIdToAdd.idNumber",
                        },
                      ],
                      staticClass: "input is-small input-rut",
                      attrs: {
                        id: "input-rut",
                        type: "text",
                        size: "is-small",
                        placeholder: "Ej: 12123123-1",
                      },
                      domProps: { value: _vm.trustedIdToAdd.idNumber },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.trustedIdToAdd,
                            "idNumber",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    { staticClass: "input-card-button" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-secondary button",
                          attrs: {
                            id: "button-cancel-person",
                            type: "is-small",
                            rounded: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showAddTrustedIdInput =
                                !_vm.showAddTrustedIdInput
                            },
                          },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "is-button-primary button",
                          attrs: {
                            id: "button-add-person",
                            type: "is-small",
                            rounded: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setOrUnsetTrustedIdNumber([
                                _vm.trustedIdToAdd,
                              ])
                            },
                          },
                        },
                        [_vm._v(" Agregar ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "trusted-ids-list" },
        [
          _vm.modifiableTrustedIdNumbers.length
            ? _c("h5", { staticClass: "transfers-title" }, [
                _vm._v("Tus personas de confianza"),
              ])
            : _vm._e(),
          _vm._l(_vm.modifiableTrustedIdNumbers, function (trustedIdNumber) {
            return _c("div", { key: trustedIdNumber.idNumber }, [
              _c("div", { staticClass: "card-item input-card" }, [
                _c("div", { staticClass: "input-card-name" }, [
                  _c("p", { staticClass: "is-size-6 is-primary p-title" }, [
                    _vm._v("Nombre:"),
                  ]),
                  _c("p", { staticClass: "p-rut" }, [
                    _vm._v(_vm._s(trustedIdNumber.name)),
                  ]),
                ]),
                _c("div", { staticClass: "input-card-rut" }, [
                  _c("p", { staticClass: "is-size-6 p-title" }, [
                    _vm._v("Rut:"),
                  ]),
                  _c("p", { staticClass: "p-rut" }, [
                    _vm._v(_vm._s(_vm.formatRut(trustedIdNumber.idNumber))),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "input-card-button" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "is-button-primary button",
                        attrs: {
                          id: "delete-button",
                          type: "is-small",
                          rounded: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setOrUnsetTrustedIdNumber([
                              {
                                idNumber: trustedIdNumber.idNumber,
                                name: trustedIdNumber.name,
                                status: "DELETED_BY_CLIENT",
                              },
                            ])
                          },
                        },
                      },
                      [_vm._v(" Eliminar ")]
                    ),
                  ],
                  1
                ),
              ]),
            ])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }